<template>
  <ion-header :class="{ web: isWeb() }">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button
          v-if="backHref"
          :default-href="backHref"
        ></ion-back-button>
        <ion-menu-button v-else data-cy="side-menu-button"></ion-menu-button>
      </ion-buttons>
      <ion-title>{{ pageTitle }}</ion-title>
      <ion-buttons slot="end">
        <slot name="end"></slot>
        <img :src="logo" alt="SS logo" class="logo" />
      </ion-buttons>
    </ion-toolbar>
    <slot></slot>
  </ion-header>
</template>

<script>
import logo from "@/assets/images/logo.png";
import { mapGetters } from "vuex";
import PlatformService from "@/services/Platform";

export default {
  props: {
    backHref: String
  },

  data: function() {
    return {
      logo
    };
  },

  methods: {
    isWeb() {
      return PlatformService.isWeb();
    }
  },

  computed: {
    ...mapGetters("auth", ["user"])
  }
};
</script>

<style lang="scss">
ion-header .logo {
  height: 40px;
  margin-right: 8px;
}

// this stops the header text from bouncing for some reason
ion-toolbar.in-toolbar ion-title {
  transition: none;
}
</style>
